import { render } from "./ReturnDetail.vue?vue&type=template&id=af8a69ba&scoped=true"
import script from "./ReturnDetail.vue?vue&type=script&lang=js"
export * from "./ReturnDetail.vue?vue&type=script&lang=js"

import "./ReturnDetail.vue?vue&type=style&index=0&id=af8a69ba&scoped=true&lang=css"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af8a69ba"]])

export default __exports__